export function toggleBodyScroll(toggle: boolean): void {
  toggle
    ? document.body.classList.add("hidden-scroll")
    : document.body.classList.remove("hidden-scroll");
}
